<template>
    <div class="content">
        <base-header class="pb-6">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h6 class="h2 text-white d-inline-block mb-0">
                        {{ $t("wms.menu.storage") }}
                    </h6>
                    <nav
                        aria-label="breadcrumb"
                        class="d-none d-md-inline-block ml-md-4"
                    >
                        <route-bread-crumb></route-bread-crumb>
                    </nav>
                </div>

                <div class="col-lg-6 col-5 text-right">
                    <base-button
                        size="md"
                        type="neutral"
                        @click="handleCreate()"
                        >{{ $t("new") }}</base-button
                    >

                    <!-- <base-button size="md" type="neutral" v-if="isCorporateAdmin || isDtacAdmin">{{
            $t("upload_file")
          }}</base-button> -->
                </div>
            </div>
        </base-header>
        <div class="container-fluid mt--6">
            <div>
                <card
                    class="no-border-card"
                    body-classes="px-0 pb-1"
                    footer-classes="pb-2"
                >
                    <template slot="header">
                        <div class="col-lg-3">
                            <base-input
                                v-model="searchQuery"
                                prepend-icon="fas fa-search"
                                :placeholder="$t('search')"
                            >
                            </base-input>
                        </div>
                    </template>
                    <div>
                        <el-table
                            :data="queriedData"
                            row-key="id"
                            header-row-class-name="thead-light"
                            @sort-change="sortChange"
                            @selection-change="selectionChange"
                        >
                            <el-table-column
                                v-for="column in tableColumns"
                                :key="column.label"
                                v-bind="column"
                            >
                            </el-table-column>
                            <el-table-column
                                min-width="200px"
                                align="right"
                                :label="$t('actions')"
                            >
                                <div
                                    slot-scope="{ $index, row }"
                                    class="d-flex"
                                >
                                    <base-button
                                        @click.native="handleEdit($index, row)"
                                        class="edit"
                                        type="warning"
                                        size="sm"
                                        icon
                                    >
                                        <i class="text-dtac-bt fa fa-edit"></i>
                                    </base-button>
                                    <base-button
                                        @click.native="
                                            handleDelete($index, row)
                                        "
                                        class="remove btn-link"
                                        type="danger"
                                        size="sm"
                                        icon
                                    >
                                        <i class="text-dtac-bt fa fa-trash text-white"></i>
                                    </base-button>
                                </div>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div
                        slot="footer"
                        class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
                        v-if="tableData.length != 0"
                    >
                        <div class="">
                            <p class="card-category">
                                {{ $t("data") }} {{ from + 1 }} {{ $t("to") }}
                                {{ to }}
                                {{ $t("of") }}
                                {{ total }}
                                <span v-if="selectedRows.length">
                                    - &nbsp; &nbsp; {{ selectedRows.length }}
                                    {{ $t("row_select") }}
                                </span>
                            </p>
                        </div>
                        <base-pagination
                            class="pagination-no-border"
                            v-model="pagination.currentPage"
                            :per-page="pagination.perPage"
                            :total="total"
                        >
                        </base-pagination>
                    </div>
                </card>
            </div>
        </div>

        <modal :show.sync="showAddModal" modal-classes="modal-secondary">
            <form class="new-event--form" @submit.prevent="saveEvent">
                <base-input :label="$t('name')" v-model="md.name"> </base-input>

                <base-input :label="$t('description')" v-model="md.desc">
                </base-input>

                <base-input :label="$t('location_x')" v-model="md.x">
                </base-input>

                <base-input :label="$t('location_y')" v-model="md.y">
                </base-input>

                <input type="hidden" class="new-event--start" />
                <input type="hidden" class="new-event--end" />
            </form>

            <template slot="footer">
                <button
                    type="submit"
                    class="btn btn-md btn-primary"
                    @click="handleUpdate()"
                >
                    {{ $t("save") }}
                </button>
                <button
                    type="button"
                    class="btn btn-md btn-link ml-auto"
                    @click="showAddModal = false"
                >
                    {{ $t("close") }}
                </button>
            </template>
        </modal>
    </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "../PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";

export default {
    mixins: [clientPaginationMixin],
    components: {
        BasePagination,
        RouteBreadCrumb,
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn
    },
    computed: {
        ...mapGetters({
            tableDataOrg: "WmsStorage/getData"
        }),
        tableData: function() {
            // if (this.$route.query.id != null) {
            //   return this.tableDataOrg.filter((m)=>{
            //     return m.EnterpriseID == "" + this.$route.query.id
            //   });
            // }

            return this.tableDataOrg;
        },
        tableColumns: function() {
            return [
                {
                    prop: "Name",
                    label: this.$t("wms.storage_name"),
                    minWidth: 90,
                    sortable: true
                },
                {
                    prop: "LocationDesc",
                    label: this.$t("wms.storage_desc"),
                    minWidth: 100,
                    sortable: true
                },
                {
                    prop: "X",
                    label: this.$t("wms.x"),
                    minWidth: 120,
                    sortable: true
                },
                {
                    prop: "Y",
                    label: this.$t("wms.y"),
                    minWidth: 90,
                    sortable: true
                }
            ];
        }
    },
    data() {
        return {
            propsToSearch: ["Number", "Email"],
            selectedRows: [],
            showAddModal: false,
            md: {
                id: 0,
                name: "",
                desc: "",
                x: "",
                y: ""
            }
        };
    },
    mounted() {
        this.listData();
    },
    methods: {
        ...mapActions({
            createData: "WmsStorage/createData",
            updateData: "WmsStorage/updateData",
            deleteData: "WmsStorage/deleteData",
            listData: "WmsStorage/listData"
        }),
        handleCreate(action) {
            this.showAddModal = true;
            this.md.id = 0;
            this.md.name = "";
            this.md.desc = "";
            this.md.x = "";
            this.md.y = "";
        },
        handleEdit(index, row) {
            this.showAddModal = true;
            this.md.id = row.ID;
            this.md.name = row.Name;
            this.md.desc = row.LocationDesc;
            this.md.x = row.X;
            this.md.y = row.Y;
        },
        handleUpdate() {
            this.showAddModal = false;
            // Create

            if (this.md.id == 0) {
                this.createData({
                    name: this.md.name,
                    locationDesc: this.md.desc,
                    x: this.md.x,
                    y: this.md.y
                })
                    .then(resp => {
                        this.listData();
                        swal.fire({
                            title: this.$t("create_success"),
                            text: ``,
                            icon: "success",
                            confirmButtonClass: "btn btn-success btn-fill",
                            buttonsStyling: false
                        });
                    })
                    .catch(err => {
                        swal.fire({
                            title: this.$t(err.response.data.Msg),
                            text: this.getErrorText(err.response.data),
                            icon: "error",
                            confirmButtonClass: "btn btn-danger btn-fill",
                            buttonsStyling: false
                        });
                    });
            } else {
                // Update
                this.updateData({
                    id: this.md.id,
					payload: {
                    name: this.md.name,
                    locationDesc: this.md.desc,
                    x: this.md.x,
                    y: this.md.y
					}
                })
                    .then(resp => {
                        this.listData();
                        swal.fire({
                            title: this.$t("edit_success"),
                            text: ``,
                            icon: "success",
                            confirmButtonClass: "btn btn-success btn-fill",
                            buttonsStyling: false
                        });
                    })
                    .catch(err => {
                        swal.fire({
                            title: this.$t(err.response.data.Msg),
                            text: this.getErrorText(err.response.data),
                            icon: "error",
                            confirmButtonClass: "btn btn-danger btn-fill",
                            buttonsStyling: false
                        });
                    });
            }
        },
        handleDelete(index, row) {
            swal.fire({
                title: this.$t("delete_confirm"),
                text: this.$t("delete_confirm_question") + row.Name,
                icon: "warning",
                showCancelButton: true,
                confirmButtonClass: "btn btn-success btn-fill",
                cancelButtonClass: "btn btn-danger btn-fill",
                confirmButtonText: this.$t("confirm"),
                cancelButtonText: this.$t("cancel"),
                buttonsStyling: false
            }).then(result => {
                if (result.value) {
                    this.deleteData(row.ID)
                        .then(resp => {
                            this.listData();
                            swal.fire({
                                title: this.$t("delete_success"),
                                text: ``,
                                icon: "success",
                                confirmButtonClass: "btn btn-success btn-fill",
                                buttonsStyling: false
                            });
                        })
                        .catch(err => {
                            swal.fire({
                                title: this.$t(err.response.data.Msg),
                                text: this.getErrorText(err.response.data),
                                icon: "error",
                                confirmButtonClass: "btn btn-danger btn-fill",
                                buttonsStyling: false
                            });
                        });
                }
            });
        },
        selectionChange(selectedRows) {
            this.selectedRows = selectedRows;
        }
    }
};
</script>
<style>
.no-border-card .card-footer {
    border-top: 0;
}
</style>
